/**
 * User-facing message per code. The pdf-no-text-layer wording is verbatim
 * from PRD §8.4; the rest follow its voice (PRD gives no exact strings).
 */
export const PARSER_ERROR_MESSAGES = {
    'pdf-no-text-layer': "This PDF contains no text layer — OCR isn't supported yet",
    'pdf-encrypted': "This PDF is encrypted or DRM-protected — it can't be opened.",
    'corrupt-file': "This file couldn't be read — it appears to be damaged or not the format it claims.",
    'file-too-large': 'This file is larger than the 50 MB limit.',
    'too-many-words': 'This document is longer than the 2,000,000-word limit.',
    'empty-document': 'No readable text found.',
};
export class ParserError extends Error {
    code;
    constructor(code, detail) {
        super(detail === undefined ? PARSER_ERROR_MESSAGES[code] : detail);
        this.name = 'ParserError';
        this.code = code;
    }
}
//# sourceMappingURL=errors.js.map